import React from "react"

import { Button as MuiButton } from "@mui/material"

import type { ButtonProps } from "./button.types"

export const Button = (props: ButtonProps) => <MuiButton {...props} />
